import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../data/store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
/**
 * Gets the fallback value for working hours end time in calendar appearance settings
 */
export default (function () {
    return getFallbackValueIfNull(store().workingHoursEndTime, getCalendarConfiguration().WorkingHoursEndTime);
});
//# sourceMappingURL=getWorkingHoursEndTime.js.map